import React, { useState, useMemo } from "react";
import "./style.css";

// Ảnh cưới kỷ niệm đẹp nhất đưa vào trang lót photobook
const MEMORY_COVER_PHOTO = "https://lh3.googleusercontent.com/d/1eF9GN4B0vhv1S_p3CvVcTtQX1q4obJ-r";

const Preloader = ({ onComplete, onPlayMusic }) => {
  const [stage, setStage] = useState("cover"); // cover -> opening -> book_open -> exit

  // Đọc tên khách mời từ URL parameter ?name=...
  const guestName = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("name") || "";
  }, []);

  const handleOpenBook = () => {
    setStage("opening");
    setTimeout(() => {
      setStage("book_open");
    }, 1200);
  };

  const handleEnterSite = () => {
    onPlayMusic && onPlayMusic();
    window.scrollTo(0, 0);
    setStage("exit");
    setTimeout(() => {
      onComplete && onComplete();
    }, 800);
  };

  if (stage === "exit") {
    return (
      <div className="preloader preloader-exit">
        <div className="preloader-content" />
      </div>
    );
  }

  return (
    <div className="preloader">
      <div className="preloader-background">
        <div className="preloader-spotlight"></div>
        <div className="bokeh-particle bokeh-1"></div>
        <div className="bokeh-particle bokeh-2"></div>
        <div className="bokeh-particle bokeh-3"></div>
        <div className="bokeh-particle bokeh-4"></div>
        <div className="bokeh-particle bokeh-5"></div>
        <div className="bokeh-particle bokeh-6"></div>
      </div>

      {/* Giai đoạn 1: Bìa cuốn Photobook Kỷ Niệm */}
      {stage === "cover" && (
        <div className="photobook-container">
          <div className="photobook-book">
            <div className="photobook-spine"></div>
            <div className="photobook-cover-front">
              <div className="gold-frame-outer">
                <div className="gold-frame-inner">
                  <div className="book-emblem">
                    <span className="emblem-icon">✨</span>
                    <span className="emblem-initials">H ♥ P</span>
                    <span className="emblem-icon">✨</span>
                  </div>

                  <div className="book-subtitle-tag">OUR JOURNEY & EVER AFTER</div>
                  
                  <h1 className="book-title-names">
                    <span>Huy Hanh</span>
                    <span className="ampersand">&</span>
                    <span>Linh Phương</span>
                  </h1>

                  <div className="book-milestones">
                    <span className="milestone-item">12.12.2024</span>
                    <span className="milestone-dot">•</span>
                    <span className="milestone-item">26.02.2026</span>
                    <span className="milestone-dot">•</span>
                    <span className="milestone-item">Forever</span>
                  </div>

                  {guestName && (
                    <div className="book-guest-greeting">
                      <span className="guest-prefix">Thân gửi:</span>
                      <span className="guest-name-highlight">{guestName}</span>
                    </div>
                  )}

                  <p className="book-quote">
                    "Khép lại hành trình hẹn hò ngọt ngào,<br />
                    Mở ra cuốn nhật ký chung đôi trăm năm."
                  </p>
                </div>
              </div>
            </div>
          </div>

          <button className="open-photobook-btn" onClick={handleOpenBook}>
            <span className="btn-book-icon">📖</span>
            <span className="btn-text">Lật Mở Kỷ Niệm</span>
          </button>
          <p className="tap-hint">Nhấn để lật mở cuốn sách ký ức của chúng mình</p>
        </div>
      )}

      {/* Giai đoạn 2: Hiệu ứng lật mở bìa sách */}
      {stage === "opening" && (
        <div className="photobook-container opening">
          <div className="photobook-book book-flipping">
            <div className="photobook-cover-front cover-turn-left">
              <div className="gold-frame-inner">
                <div className="book-emblem">
                  <span className="emblem-initials">H ♥ P</span>
                </div>
                <h2 className="book-title-names mini">Huy Hanh & Linh Phương</h2>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Giai đoạn 3: Cuốn sách mở rộng 2 trang tri ân chuẩn UI Photobook */}
      {stage === "book_open" && (
        <div className="photobook-open-container">
          {/* Vỏ bìa da cứng ôm trọn cuốn sách (Hardcover Open Base) */}
          <div className="hardcover-open-base">
            {/* Dây ruy băng lụa đánh dấu trang */}
            <div className="book-ribbon-bookmark"></div>

            {/* Xấp giấy mỹ thuật mở đôi (The 3D Pages Spread) */}
            <div className="photobook-open-spread">
              {/* Rãnh gáy sách trung tâm với hiệu ứng đổ bóng & chỉ may */}
              <div className="book-gutter-spine">
                <div className="book-stitch-thread"></div>
              </div>

              {/* Viền xếp lớp nhiều trang giấy ở hai bên */}
              <div className="pages-edge-left"></div>
              <div className="pages-edge-right"></div>
              <div className="pages-edge-bottom"></div>

              {/* Trang trái: Bức ảnh cưới kỷ niệm */}
              <div className="spread-page spread-left">
                <div className="page-inner-border">
                  <span className="ornament-corner corner-tl">✦</span>
                  <span className="ornament-corner corner-bl">✦</span>

                  <div className="photo-mat-frame">
                    <div className="wedding-photo-wrap">
                      <img src={MEMORY_COVER_PHOTO} alt="Huy Hanh & Linh Phương" />
                    </div>
                    <div className="photo-caption">
                      <span className="caption-date">26.02.2026</span>
                      <span className="caption-title">The Day We Said "I Do"</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Trang phải: Lời tri ân & Lời ngỏ */}
              <div className="spread-page spread-right">
                <div className="page-inner-border">
                  <span className="ornament-corner corner-tr">✦</span>
                  <span className="ornament-corner corner-br">✦</span>
                  <div className="page-curl-corner" title="Trang sách kế tiếp"></div>

                  <div className="message-content">
                    <div className="message-header">
                      <span className="pre-title">Huy Hanh & Linh Phương</span>
                      <h2 className="message-title">Lời Cảm Ơn & Tri Ân</h2>
                      <div className="title-divider">❦</div>
                    </div>

                    <div className="message-body">
                      <p>
                        Chào bạn! Cảm ơn bạn đã luôn dõi theo, sẻ chia và dành những lời chúc phúc ngọt ngào nhất cho tình yêu của chúng mình.
                      </p>
                      <p>
                        Ngày <strong>26.02.2026</strong> vừa qua đã chính thức đánh dấu một cột mốc thiêng liêng — ngày chúng mình về chung một nhà, bắt đầu một mái ấm gia đình ngập tràn yêu thương và tiếng cười.
                      </p>
                      <p>
                        Trang web này từ nay sẽ là <strong>ngôi nhà kỷ niệm số</strong> — nơi lưu giữ những hồi ức đẹp, những chuyến đi, và từng chặng đường mà hai đứa cùng nhau trải nghiệm.
                      </p>
                    </div>

                    <div className="message-footer">
                      <p className="closing-quote">"Cảm ơn vì bạn đã là một phần thật đẹp trong thanh xuân của chúng mình!"</p>
                      <p className="signature-handwriting">Huy Hanh & Linh Phương 💕</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button className="enter-journey-btn" onClick={handleEnterSite}>
            <span>Khám phá Nhật Ký Chung Đôi</span>
            <span className="arrow-icon">✨ →</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Preloader;
